<template lang="pug">
div
  .sticky.top-0.z-10
    .mx-6.py-4.d-flex.align-center.white
      v-btn.ml-n2(depressed icon @click="back")
        eva-icon.d-flex(name="arrow-ios-back" fill="#888")
      .flex-grow-1.text-center.text-lg.font-medium.mr-8.capitalize {{ title }}
    v-divider
  slot(name="body")
  .py-16
  .yc-fixed-bottom-section
    .d-flex.align-center(v-if="saveMode")
      v-btn.button-md(@click="back" color="neutral500" text) {{ $t('back') }}
      v-spacer
      v-btn.button-md(@click="save" color="info500" dark depressed) {{ $t('save') }}
    .d-flex.align-center(v-else)
      v-btn.button-md.underline(@click="clear" color="neutral500" text) {{ $t('clear') }}
      v-spacer
      v-btn.button-md(@click="save" color="neutral700" dark depressed) {{ $t('apply') }}
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    saveMode: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    save() {
      this.$emit('save')
    },
    clear() {
      this.$emit('clear')
    }
  }
}
</script>